import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "confirm-wrap"
};
const _hoisted_2 = {
  key: 1
};
import { computed, reactive } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'PlainButton',
  props: {
    type: null,
    disabled: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const type_class_name_map = reactive({
      cancel: 'button-cancel'
    });
    const mainClassName = computed(() => {
      const typeClassName = type_class_name_map[props.type] || 'button-confirm';
      const classNameArr = [typeClassName];
      if (props.disabled) classNameArr.push('disabled');
      return classNameArr;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["plain-button", _unref(mainClassName)])
      }, [__props.type === 'confirm' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, [_renderSlot(_ctx.$slots, "default")])])) : _createCommentVNode("", true), __props.type !== 'confirm' ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_renderSlot(_ctx.$slots, "default")])) : _createCommentVNode("", true)], 2);
    };
  }
});